import badgeExplorer from "@assets/web-v3-images/icons/badge-explorer.png";
import badgeMaster from "@assets/web-v3-images/icons/badge-master.png";
import crownIcon from "@assets/web-v3-images/icons/crown-coin-icon.png";
import winRewardBg from "@assets/web-v3-images/win-reward-section-bg.png";
import { useTranslation } from "react-i18next";

/**
 * Khối "Win reward": nền là 1 ảnh gộp sẵn đống quà + pill tiêu đề + thân card
 * (win-reward-section-bg.png, tỉ lệ 816×558). Trên nền chỉ overlay:
 *   - chữ tiêu đề "Win reward" phủ đúng pill (tâm ~42% chiều cao)
 *   - 2 ô hạng thưởng nằm trong thân card
 * Vị trí/kích thước theo % + cqw nên co giãn theo bề rộng section.
 */
const WinRewardSection = ({ tiers }) => {
  const { t } = useTranslation();

  return (
    <section className="@container relative">
      <img src={winRewardBg} alt="" className="block w-full" />

      <h2 className="absolute left-1/2 top-[35%] w-max max-w-[60%] -translate-x-1/2 -translate-y-[70%] truncate text-center text-[15px] sm:text-[25px] font-extrabold text-[#772917]">
        {t("daily_reward.win_reward")}
      </h2>

      <div className="absolute inset-x-[4%] top-[46%] bottom-[4%] flex gap-[2cqw]">
        {tiers?.length > 0 && tiers.map((tier) => {
          return (
            <TierBox
              key={tier?.key}
              name={tier?.label}
              lp={tier?.reward_lp}
              badge={tier?.rank === "MASTER" ? badgeMaster : badgeExplorer}
            />
          )
        }
        )}
      </div>
    </section>
  );
};

/** Một ô hạng thưởng: tên + huy hiệu ở trên, xu vương miện + số LP ở dưới. */
const TierBox = ({ name, lp, badge }) => (
  <div className="rounded-[3cqw] border-[3px] border-transparent [background:linear-gradient(#FFFDF2,#FFFDF2)_padding-box,linear-gradient(90deg,#FFB86C_0%,#FFE8D0_50%,#FFD8A1_100%)_border-box] w-full px-[3cqw] py-[2cqw] h-fit">
    <div className="flex items-center justify-between">
      <p className="min-w-0 truncate font-extrabold text-[#3F1D0B] text-[3.7cqw]">
        {name}
      </p>
      <img src={badge} alt="" className="w-[10cqw] shrink-0 object-contain" />
    </div>
    <div className="mt-[1cqw] flex items-center gap-[1.5cqw]">
      <img src={crownIcon} alt="" className="w-[10cqw] shrink-0 object-contain" />
      <p className="truncate bg-linear-[135deg,#F49062_0%,#FD371F_100%] bg-clip-text text-[5.5cqw] font-extrabold text-transparent">
        {lp?.toLocaleString("en-US")} LP
      </p>
    </div>
  </div>
);

export default WinRewardSection;
